import { render, staticRenderFns } from "./saledaily.vue?vue&type=template&id=1d10a572&"
import script from "./saledaily.vue?vue&type=script&lang=js&"
export * from "./saledaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports